"use client";

import Image, { type ImageProps } from "next/image";
import { useState } from "react";

type Props = Omit<ImageProps, "src"> & {
  src: string;
  fallback: string;
};

export function SmartImage({ src, fallback, alt, ...props }: Props) {
  const [current, setCurrent] = useState(src);

  return (
    <Image
      {...props}
      src={current}
      alt={alt}
      onError={() => {
        if (current !== fallback) setCurrent(fallback);
      }}
      // keep bg muted while loading so CLS is subtle
      className={`${props.className ?? ""} bg-[var(--muted)]`}
    />
  );
}
